export default {
    locale: 'nb-NO',
    dismissAlertText: 'Lukk'
};
